import { getBadgeColor, getDomainLabel } from '@/utils/domainHelpers';

interface LinkBadgeProps {
  source: string;
  className?: string;
}

export function LinkBadge({ source, className = '' }: LinkBadgeProps) {
  return (
    <span
      className={`px-2 py-1 text-xs font-medium rounded ${getBadgeColor(source)} ${className}`}
    >
      {getDomainLabel(source)}
    </span>
  );
}
